<template>
  <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path :fill="color" d="M49.61,32.06c-1.74,0-3.21-.59-4.4-1.78-1.19-1.19-1.78-2.65-1.78-4.4s.59-3.21,1.78-4.4c1.19-1.19,2.65-1.78,4.4-1.78s3.21.59,4.4,1.78c1.19,1.19,1.78,2.65,1.78,4.4s-.59,3.21-1.78,4.4c-1.19,1.19-2.65,1.78-4.4,1.78ZM40.34,79.07v-37.18c0-.39-.19-.76-.5-.99l-.92-.68c-4.14-3.05-7.76-6.75-10.72-10.96l-1.07-1.52c-.36-.52-.27-1.23.22-1.64l3.22-2.7c.52-.43,1.29-.37,1.72.15l5.51,6.59c2.54,3.03,6.28,4.78,10.24,4.78h27.67c.68,0,1.22.55,1.22,1.22v3.89c0,.68-.55,1.22-1.22,1.22h-15.6c-.68,0-1.22.55-1.22,1.22v36.57c0,.68-.55,1.22-1.22,1.22h-3.89c-.68,0-1.22-.55-1.22-1.22v-15.83c0-.68-.55-1.22-1.22-1.22h-3.43c-.68,0-1.22.55-1.22,1.22v15.83c0,.68-.55,1.22-1.22,1.22h-3.89c-.68,0-1.22-.55-1.22-1.22Z"/>
  </svg>
</template>

<script>
export default {
  name: 'PeopleIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
